<div id="pronto-pago-verificacion">

  <app-card Theme="card-primary background-white">
    <div card-content>
      <app-body Theme="body-normal">
        <div body-content>

          <!-- Título + stepper (paso 1 ✓ completado, paso 2 activo) -->
          <div class="cabecera-paso">
            <h2 class="titulo-paso">Verificación por correo <span class="titulo-paso__sub">| Confirma tu identidad para firmar</span></h2>
            <ol class="stepper">
              <li class="stepper__paso stepper__paso--completado">
                <span class="stepper__circulo">✓</span>
                <span class="stepper__label">Oferta</span>
              </li>
              <li class="stepper__linea stepper__linea--activa"></li>
              <li class="stepper__paso stepper__paso--activo">
                <span class="stepper__circulo">{{ pasoActual }}</span>
                <span class="stepper__label">Verificación</span>
              </li>
            </ol>
          </div>

          <!-- Error en el primer envío del código: permite reintentar -->
          <div class="tarjeta-codigo" *ngIf="errorEnvio && !info && !sinAcceso">
            <p class="mensaje-error">No pudimos enviar el código a tu correo. Inténtalo nuevamente.</p>
            <a class="reenviar" [class.reenviar--off]="enviando" (click)="enviarCodigo()">Reintentar envío</a>
          </div>

          <!-- Sin acceso al correo (o el envío falló en todos los intentos): alternativa presencial -->
          <div class="tarjeta-sin-acceso" *ngIf="sinAcceso">
            <div class="tarjeta-sin-acceso__cabecera">
              <span class="icono-alerta" aria-hidden="true">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#C08A00" stroke-width="1.8">
                  <path d="M12 9v4M12 17h.01M10.3 3.9l-8 14A2 2 0 004 21h16a2 2 0 001.7-3.1l-8-14a2 2 0 00-3.4 0z"></path>
                </svg>
              </span>
              <h3 class="tarjeta-sin-acceso__titulo">No pudimos verificar tu identidad</h3>
              <p class="tarjeta-sin-acceso__texto" *ngIf="motivoSinAcceso === 'sin-acceso'">
                Indicaste que ya no tienes acceso al correo
                <b *ngIf="info">{{ info.correoEnmascarado }}</b>. Por tu seguridad no podemos continuar
                la firma por este medio.
              </p>
              <p class="tarjeta-sin-acceso__texto" *ngIf="motivoSinAcceso === 'sin-correo'">
                No tienes un correo registrado en Colmena, así que no podemos enviarte el código de
                verificación para firmar por este medio.
              </p>
              <p class="tarjeta-sin-acceso__texto" *ngIf="motivoSinAcceso === 'limite-envios'">
                Superaste el máximo de envíos de código de verificación. Puedes intentarlo
                nuevamente más tarde o validar tu identidad en una sucursal.
              </p>
              <p class="tarjeta-sin-acceso__texto" *ngIf="motivoSinAcceso === 'envio-fallido'">
                No pudimos enviarte el código de verificación después de {{ enviosMaximos }} intentos.
                Por tu seguridad no podemos continuar la firma por este medio.
              </p>
            </div>

            <p class="tarjeta-sin-acceso__como">¿Cómo seguir con tu Pago Anticipado?</p>

            <div class="opciones-sin-acceso">
              <div class="opcion">
                <p class="opcion__titulo">En una sucursal</p>
                <p class="opcion__texto">
                  Acércate a una sucursal Colmena con tu cédula de identidad para validar tu identidad
                  de forma presencial. Tu oferta sigue vigente.
                </p>
                <a class="opcion__cta" href="https://www.colmena.cl/sucursales/" target="_blank" rel="noreferrer">Ver sucursales</a>
              </div>
            </div>

            <div class="tarjeta-sin-acceso__volver">
              <a class="volver" (click)="volver.emit()">‹ Volver a la propuesta</a>
            </div>
          </div>

          <!-- Tarjeta central de verificación -->
          <div class="tarjeta-codigo" *ngIf="info && !sinAcceso">

            <div class="tarjeta-codigo__cabecera">
              <span class="icono-sobre" aria-hidden="true">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#0078C8" stroke-width="1.6">
                  <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                  <path d="M3 7l9 6 9-6"></path>
                </svg>
              </span>
              <h3 class="tarjeta-codigo__titulo">Ingresa tu código de autenticación</h3>
              <p class="tarjeta-codigo__texto">
                Enviamos un código de <b>{{ info.largoCodigo }} caracteres</b> a<br/>
                <b>{{ info.correoEnmascarado }}</b>. Ingrésalo para firmar tu acuerdo de Pronto Pago.
              </p>
            </div>

            <!-- Contador de vigencia -->
            <p class="vigencia" [class.vigencia--expirada]="expirado">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M12 7v5l3 2"></path>
              </svg>
              <ng-container *ngIf="!expirado">Tu código vence en <b class="tabular">{{ vigenciaFormateada }}</b></ng-container>
              <ng-container *ngIf="expirado && quedanEnvios">Tu código expiró. Reenvíalo para continuar.</ng-container>
              <ng-container *ngIf="expirado && !quedanEnvios">Tu código expiró y no quedan reenvíos disponibles.</ng-container>
            </p>

            <!-- Input del código -->
            <div class="campo-codigo">
              <label for="codigo-pp">Código de autenticación</label>
              <input id="codigo-pp"
                     type="text"
                     placeholder="________"
                     maxlength="8"
                     autocomplete="one-time-code"
                     [(ngModel)]="codigo"
                     [disabled]="bloqueado || expirado" />

              <div class="campo-codigo__estado">
                <span>{{ codigo.length }}/{{ info.largoCodigo }} · Intento {{ intentoMostrado }} de {{ info.intentosMaximos }}</span>
                <a class="reenviar"
                   *ngIf="quedanEnvios"
                   [class.reenviar--off]="enviando"
                   (click)="enviarCodigo()">{{ enviando ? 'Reenviando…' : 'Reenviar código' }}</a>
              </div>

              <p class="mensaje-error" *ngIf="limiteEnvios">
                Superaste el máximo de envíos de código. Inténtalo nuevamente más tarde.
              </p>
              <p class="mensaje-error" *ngIf="errorEnvio && !limiteEnvios">
                No pudimos reenviar el código a tu correo.
                <ng-container *ngIf="quedanEnvios">Inténtalo nuevamente.</ng-container>
              </p>
              <p class="mensaje-error" *ngIf="error && !bloqueado">{{ error }}</p>
              <p class="mensaje-error" *ngIf="bloqueado && quedanEnvios">
                Agotaste los intentos. Reenvía el código para volver a intentarlo.
              </p>
              <p class="mensaje-error" *ngIf="bloqueado && !quedanEnvios">
                Agotaste los intentos y los reenvíos disponibles.
              </p>
            </div>

            <app-button Theme="button-primary"
                        class="boton-validar"
                        [class.boton-validar--off]="!puedeValidar"
                        [Label]="'<p>Validar y firmar</p>'"
                        [IcoSvg]="null"
                        [Loading_sk]="validando"
                        (click)="validar()"></app-button>

            <div class="no-acceso">
              <a (click)="noTengoAcceso()">Ya no tengo acceso a este correo / No es mi correo</a>
            </div>

          </div>

          <div class="pie-volver" *ngIf="!sinAcceso">
            <a class="volver" (click)="volver.emit()">‹ Volver</a>
          </div>

        </div>
      </app-body>
    </div>
  </app-card>
</div>
